export type IsoDateString = string;

export function toTime(d: IsoDateString): number {
  // Interpret as local midnight; input is YYYY-MM-DD.
  const t = Date.parse(`${d}T00:00:00`);
  return Number.isFinite(t) ? t : NaN;
}

/** Latest point with date <= asOfDate. Assumes pts can be unsorted. */
export function latestAsOf<T extends { date: IsoDateString }>(
  pts: T[],
  asOfDate: IsoDateString
): T | null {
  const asOf = toTime(asOfDate);
  if (!Number.isFinite(asOf)) return null;
  let best: T | null = null;
  let bestT = -Infinity;
  for (const p of pts) {
    const t = toTime(p.date);
    if (!Number.isFinite(t)) continue;
    if (t <= asOf && t > bestT) {
      bestT = t;
      best = p;
    }
  }
  return best;
}

/** Point immediately before the latestAsOf point. */
export function previousBeforeAsOf<T extends { date: IsoDateString }>(
  pts: T[],
  asOfDate: IsoDateString
): T | null {
  const current = latestAsOf(pts, asOfDate);
  if (!current) return null;
  const curT = toTime(current.date);
  let best: T | null = null;
  let bestT = -Infinity;
  for (const p of pts) {
    const t = toTime(p.date);
    if (!Number.isFinite(t)) continue;
    if (t < curT && t > bestT) {
      bestT = t;
      best = p;
    }
  }
  return best;
}
